module.exports = __webpack_public_path__ + "static/img/analysis.8b03307a.png";